import {Component} from '@angular/core';
import {SignatureComponent} from "./signature/signature.component";
import {SignComponent} from "./sign/sign.component";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {NgIf} from "@angular/common";
import {Button} from "primeng/button";
import {TranslateService} from "@ngx-translate/core";
import {SignatureLevel} from "./model/signer-model";
import {SubscriptionsService} from "./services/subscriptions.service";
import {SipoService} from "./services/SipoService";

@Component({
    selector: 'app-sipo',
    standalone: true,
    imports: [
        SignatureComponent,
        NgIf,
        Button,
    ],
    templateUrl: './sipo.component.html',
    styleUrl: './sipo.component.scss'
})
export class SipoComponent {
    ref!: DynamicDialogRef;
    isSessionExpired = false;

    constructor(private dialogService: DialogService,
                private translate: TranslateService,
                private subscriptionsService: SubscriptionsService,
                private sipoService: SipoService
    ) {
    }

    showPropertyForm() {

        this.ref = this.dialogService.open(SignComponent, {
            header: this.translate.instant('sipo.sign'),
            height: 'fit-content',
            width: '105rem',
            //height: '30rem',
            maximizable: true,
            closable: false,
            showHeader: true,
            data: {},

        });


        this.ref.onClose.subscribe(value => {
            if (value) {
                const paymentCert = [SignatureLevel.MAX, SignatureLevel.HIGH].includes(value);
                if (paymentCert) {
                    this.subscriptionsService.refreshCreditValue.next(new Date());
                }
                this.sipoService.reloadData.next(new Date());
            }
        });
    }

    cancelSign() {
        this.ref.close();
    }

    signEvent($event: string) {
        this.showPropertyForm();
    }

    reloadThePage(): void {
        window.location.reload();
    }

}
